{
    "Profile_Drivers_Conviction.drivingConviction": "FR: Driving Conviction",
    "Profile_Drivers_Conviction.drivingConvictionDetails": "FR: Driving Conviction Details",
    "Profile_Drivers_Conviction.dateOfConviction": "FR: Date of Conviction",
    "Profile_Drivers_Conviction.convictionReason": "FR: Conviction Reason"
}
